import { render, staticRenderFns } from "./ModalDescount.vue?vue&type=template&id=8bf1a914&"
import script from "./ModalDescount.vue?vue&type=script&lang=js&"
export * from "./ModalDescount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports